import TM_LOGO_WHITE from "@assets/tm_logo_white.png";
import { ReactElement } from "react";

export default function QnFooter(): ReactElement {
  return (
    <div className="hidden md:flex fixed bottom-4 left-8 z-40 items-center gap-2 text-neutral-300">
      <img className="block w-[217px]" alt="Home" src={TM_LOGO_WHITE} />
    </div>
  );
}
